import React, { useEffect, useMemo, useState } from 'react';
import { loadable } from 'react-lazily/loadable';
import { useForm } from 'react-hook-form';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import { useHistory, useParams } from 'react-router-dom';
import { getReactSelectedValue, UrlFirstSegment, validationRule } from 'utils/global';
import { RootReducerState } from 'reduxStore/rootReducers';
import { updateSmeLoanApplication } from 'utils/services';
import { loanApplicationRoutes, yesOrNoOptionList } from 'utils/constants';
import { GET_SME_LOAN_INFORMATION_SUCCESS } from 'reduxStore/actionTypes';
const { FormErrorMessage } = loadable(() => import('components/forms'), {
fallback: <>Loading...</>,
});
const { ReactFormSelect } = loadable(() => import('components/forms'), {
fallback: <>Loading...</>,
});
const { TextBox } = loadable(() => import('components/forms'), {
fallback: <>Loading...</>,
});
const { MaskTextBox } = loadable(() => import('components/forms'), {
fallback: <>Loading...</>,
});
const { NepaliFormCalendar } = loadable(() => import('components/forms'), {
fallback: <>Loading...</>,
});
const { HoverLoader } = loadable(() => import('components'), {
fallback: <>Loading...</>,
});

let defaultValues = {
	credit_card: '',
	pos: '',
	qr_code: '',
	online_banking: '',
	mobile_banking: '',
	name_bank_with_credit_card: '',
	name_bank_with_pos: '',
	name_bank_with_qrcode: '',
	name_bank_with_online_banking: '',
	name_bank_with_mobile_banking: '',
	terms_condition: '',
};

const termsAndConditionArray = [
	{
		label: 'I here by declare that the information provided is true and correct. I also understand that any willful dishonesty may render for refusal of this application form.',
		value: 1,
		isAdded: false,
	},
	{
		label:
			'I/We confirm that my/our firm/company and director/partner/promoter/guarantor is/are not blacklisted by Credit Information Center Limited. I/We shall be obliged to provide any other documents/information as required by Nabil Bank Ltd for further process.',
		value: 2,
		isAdded: false,
	},
	{
		label: "I/We agree that the bank may refer my/our name's to a recognized credit or referencing agencies or financial institutions and make such references as the bank consider it necessary.",
		value: 3,
		isAdded: false,
	},
	{
		label: "I/We agree that the bank in its sole decision may reject my/our application without any reason's and that I/We agree not right to appeal against decision of the bank.",
		value: 4,
		isAdded: false,
	},

];

const LoanApplicationStepThree = () => {
	const scrollParam = true;
	const intl = useIntl();
	const params = useParams<{ id: string; step: string }>();
	const history = useHistory();
	const dispatch = useDispatch();
	const urlFirstSegment = UrlFirstSegment();
	const [isCreditCard, setIsCreditCard] = useState<boolean>(false);
	const [isPos, setIsPos] = useState<boolean>(false);
	const [isQrCode, setISQrCode] = useState<boolean>(false);
	const [termsCondition, setTermsCondition] = useState<any>(termsAndConditionArray);
	const [isOnlineBanking, setIsOnlineBanking] = useState<boolean>(false);
	const [isMobileBanking, setIsMobileBanking] = useState<boolean>(false);
	const [isDraft, setIsDraft] = useState<any>(false);
	const [miniStep, setMiniStep] = useState<number>(1);

	const { applicationInformation } = useSelector(
		({ loanApplicationReducer }: RootReducerState) => ({
			applicationInformation: loanApplicationReducer.applicationInformation.data,
		}),
		shallowEqual
	);

	const [updateSMELoanData, setUpdateSMELoanData] = useState({ loading: false, error: false, success: false, errors: {} });

	const { register, handleSubmit, errors, control, reset, setError, setValue, getValues, watch, clearErrors } = useForm<any>({
		mode: 'all',
		defaultValues: useMemo(() => applicationInformation, [applicationInformation]),
	});

	useEffect(() => {
		if (params?.step) {
			setMiniStep(Number(params.step));
		}
	}, [params]);

	const onSubmit = (data) => {
		data.save_draft = false;
		data.form_section = miniStep === 1 ? 'financial_information' : miniStep === 2 ? 'credit_history' : miniStep === 3 ? 'facilities_availed_from_other_banks' : 'terms_conditions';
		data.sales = String(data.sales).replace(/,/g, '') || '';
		data.sales_till_date = String(data.sales_till_date).replace(/,/g, '') || '' ;
		data.net_profit = String(data.net_profit).replace(/,/g, '') || '';
		data.paid_up_capital = String(data.paid_up_capital).replace(/,/g, '') || '';
		data.facilities_availing = data?.facilities_availing ?? '';
		data.currently_availing_loan = data?.currently_availing_loan ?? '';
		data.duration_firm_availing_loan = data?.duration_firm_availing_loan ?? '';
		data.loan_size_availed = data?.loan_size_availed ?? '';
		data.facilities_being_availed = data?.facilities_being_availed ?? '';
		data.name_bank_with_credit_card = data?.name_bank_with_credit_card ?? '';
		data.name_bank_with_pos = data?.name_bank_with_pos ?? '';
		data.name_bank_with_qrcode = data?.name_bank_with_qrcode ?? '';
		data.name_bank_with_online_banking = data.name_bank_with_online_banking ?? '';
		data.name_bank_with_mobile_banking = data?.name_bank_with_mobile_banking ?? '';
		handleSubmitSME(data);
	};

	const handleSubmitDraft = () => {
		let data = getValues();
		data.mini_step = miniStep;
		data.form_section = miniStep === 1 ? 'financial_information' : miniStep === 2 ? 'credit_history' : miniStep === 3 ? 'facilities_availed_from_other_banks' : 'terms_conditions';
		data.sales = String(data.sales).replace(/,/g, '') || '';
		data.sales_till_date = String(data.sales_till_date).replace(/,/g, '') || '';
		data.net_profit = String(data.net_profit).replace(/,/g, '') || '';
		data.paid_up_capital = String(data.paid_up_capital).replace(/,/g, '') || '';
		data.facilities_availing = data?.facilities_availing ?? '';
		data.currently_availing_loan = data?.currently_availing_loan ?? '';
		data.duration_firm_availing_loan = data?.duration_firm_availing_loan ?? '';
		data.loan_size_availed = data?.loan_size_availed ?? '';
		data.facilities_being_availed = data?.facilities_being_availed ?? '';
		data.name_bank_with_credit_card = data?.name_bank_with_credit_card ?? '';
		data.name_bank_with_pos = data?.name_bank_with_pos ?? '';
		data.name_bank_with_qrcode = data?.name_bank_with_qrcode ?? '';
		data.name_bank_with_online_banking = data.name_bank_with_online_banking ?? '';
		data.name_bank_with_mobile_banking = data?.name_bank_with_mobile_banking ?? '';
		data.save_draft = true;
		handleSubmitSME(data);
	};

	const handleSubmitSME = (data) => updateSmeLoanApplication(updateSMELoanData, setUpdateSMELoanData, 'update_other_details_for_sme_loan', params.id, data);

	const onAddingItem = (item) => {
		const isChecked = item.target.checked;
		const value = item.target.value;
		setTermsCondition((prevState) => prevState.map((item) => (item.value == value ? { ...item, isAdded: isChecked} : item)));
		if (isChecked ) {
			setValue('terms_condition', (prevState) => [...prevState.terms_condition, value]);
		} else {
			const newArray = watch('terms_condition').filter((item) => item !== value);
			setValue('terms_condition', newArray);
		}
	};
	
	const onCheckingTerms= (item) => {
		const isChecked = item.target.checked;
		termsAndConditionArray.every((item)=>({...item, isAdded: isChecked}))
		if(isChecked === true){
			item.required = true;
		}			
	}
	

	useEffect(() => {
		if (applicationInformation && Object.keys(applicationInformation).length > 0) {
			const { other_details,security_details,terms_condition } = applicationInformation;
			const resetFormValue = {
				...security_details,
				...other_details,
			};
			if (terms_condition) {
				setTermsCondition((prevState) => prevState.map((item) => (terms_condition?.split(',').map(Number).includes(Number(item.value)) ? { ...item, isAdded: true} : item)));
			}
			reset(resetFormValue);
		} else {
			reset(defaultValues);
		}
	}, [applicationInformation]);

	useEffect(() => {
		if (updateSMELoanData.success) {
			let activeStep = loanApplicationRoutes.find((route) => route.id == '4');
			if (activeStep && !isDraft && miniStep === 4) {
				dispatch({ type: GET_SME_LOAN_INFORMATION_SUCCESS, payload: { data: null, informationId: null } });
				history.push({pathname: `/${urlFirstSegment + activeStep.path}`, state: scrollParam});
			} else if (updateSMELoanData.success && !isDraft) {
				let activeStep = loanApplicationRoutes.find((route) => route.id == '3');
				history.push({pathname: `/${urlFirstSegment + activeStep.path}/${Number(params?.step) + 1}/${params?.id}`, state: scrollParam});
			}
		}
	}, [updateSMELoanData.success]);

	useEffect(() => {
		if (updateSMELoanData.error) {
			Object.keys(updateSMELoanData.errors).map((err) => {
				setError(err, {
					type: 'manual',
					message: updateSMELoanData.errors[err],
				});
			});
		}
	}, [updateSMELoanData.error]);

	return (
		<>
			{miniStep === 1 ? (
				<form onSubmit={handleSubmit(onSubmit)}>
					<div className="row formLayout-row">
						<div className="col-12 ">
							<h4 className="formHeading">
								<FormattedMessage id="Financial Information" />
							</h4>
							<span className="text-danger mb-3">(As per the latest audited financial statement)</span>
						</div>
					<TextBox type="hidden"  name="miniStep" value="1" />
						<div className="col-lg-4">
							<MaskTextBox
								containerclassname="form-group"
								label="Sales"
								className="form-control"
								name="sales"
								control={control}
								inputMode="numeric"
								placeholder='Amount in "000"'
								maskOptions={{
									includeThousandsSeparator: true,
									allowLeadingZeroes: true,
									integerLimit: 15,
								}}
								rules={validationRule.textbox({ required: false })}
								error={errors.sales}
							/>
						</div>
						<div className="col-lg-4">
							<MaskTextBox
								containerclassname="form-group"
								className="form-control"
								label="Net Profit"
								name="net_profit"
								control={control}
								placeholder='Amount in "000"'
								inputMode="numeric"
								maskOptions={{
									includeThousandsSeparator: true,
									allowLeadingZeroes: true,
									integerLimit: 15,
								}}
								rules={validationRule.textbox({ required: false })}
								error={errors.net_profit}
							/>
						</div>
						<div className="col-lg-4">
							<MaskTextBox
								containerclassname="form-group"
								className="form-control"
								label="Paid Up Capital"
								name="paid_up_capital"
								control={control}
								placeholder='Amount in "000"'
								inputMode="numeric"
								maskOptions={{
									includeThousandsSeparator: true,
									allowLeadingZeroes: true,
									integerLimit: 15,
								}}
								rules={validationRule.textbox({ required: false })}
								error={errors.paid_up_capital}
							/>
						</div>
						<div className="col-lg-4">
							<MaskTextBox
								containerclassname="form-group"
								className="form-control"
								label="Current Year Sales Till Date"
								name="sales_till_date"
								control={control}
								placeholder='Amount in "000"'
								inputMode="numeric"
								maskOptions={{
									includeThousandsSeparator: true,
									allowLeadingZeroes: true,
									integerLimit: 15,
								}}
								rules={validationRule.textbox({ required: false })}
								error={errors.sales_till_date}
							/>
						</div>
					</div>
					<div className="row formLayout-footer">
						<div className="col-12 text-right">
							<div className="bg-grey">
								<button
									type="button"
									onClick={() => {
										let activeStep = loanApplicationRoutes.find((route) => route.id == '2');
										//history.push(`/${urlFirstSegment + activeStep.path}/4/${params.id}`);
										window.location.href=`/${urlFirstSegment + activeStep.path}/4/${params.id}`
									}}
									className="btn btn-primary--solid px-4 py-2 btn-sm btn--medium  ml-2 "
								>
									Previous
								</button>
								<button
									type="button"
									title='Save the record to continue later.'
									onClick={() => {
										setIsDraft(true);
										clearErrors();
										handleSubmitDraft();
									}}
									className="btn btn-primary--solid px-4 py-2 btn-sm btn--medium  ml-2 "
								>
									Save to draft
								</button>
								<button
									type="submit"
									title='Save the record to continue later.'
									onClick={(e) => {
										// e.preventDefault();
										setIsDraft(false);
									}}
									className="btn btn-gradient--solid px-4 py-2 btn-sm btn--medium   ml-2"
								>
									Next and continue
								</button>
							</div>
						</div>
					</div>
					{updateSMELoanData.loading && <HoverLoader />}
				</form>
			) : miniStep === 2 ? (
				<form onSubmit={handleSubmit(onSubmit)}>
					<div className="row">
						<div className="col-12">
							<h4 className="formHeading">
								<FormattedMessage id="Credit History" />
							</h4>
						</div>
					<TextBox type="hidden"  name="miniStep" value="2" />
						<div className="col-md-4">
							<ReactFormSelect
								containerclassname="form-group"
								required
								label="Banking Relationship With NABIL BANK Ltd."
								options={yesOrNoOptionList}
								name={'banking_relation'}
								value={getReactSelectedValue(yesOrNoOptionList, watch('banking_relation'))}
								onChange={(selected) => {
									setValue('banking_relation', selected.value);
								}}
								rules={{
									required: true,
								}}
								control={control}
								error={errors?.banking_relation}
							/>
						</div>
						{watch('banking_relation') === 'yes' && (
							<div className="col-md-4">
								<TextBox
									// required
									label="Facilities Availing From NABIL BANK Ltd."
									placeholder="Please enter your response"
									containerclassname="form-group"
									name="facilities_availing"
									type="text"
									ref={register({
										// required: true,
										maxLength: {
											value: 40,
											message: 'Maximum characters',
										},
									})}
									error={errors.facilities_availing}
								/>
							</div>
						)}
					</div>

					<div className="row formLayout-row">
						<div className="col-md-4">
							<ReactFormSelect
								containerclassname="form-group"
								required
								label="Banking Relationship With Other Banks?"
								options={yesOrNoOptionList}
								name={'other_bank_relation'}
								value={getReactSelectedValue(yesOrNoOptionList, watch('other_bank_relation'))}
								onChange={(selected) => {
									setValue('other_bank_relation', selected.value);
								}}
								rules={{
									required: true,
								}}
								control={control}
								error={errors?.other_bank_relation}
							/>
						</div>
						{watch('other_bank_relation') === 'yes' && (
							<React.Fragment>
								<div className="col-md-4">
									<TextBox
										// required
										label="Name of The Bank Currently Availing Loan"
										placeholder="Please enter your response"
										containerclassname="form-group"
										name="currently_availing_loan"
										type="text"
										ref={register({
											// required: true,
											maxLength: {
												value: 40,
												message: 'Maximum characters',
											},
										})}
										error={errors.currently_availing_loan}
									/>
								</div>
								<div className="col-md-4">
									<TextBox
										// required
										label="Types of Facilities Being Availed"
										placeholder="Please enter your response"
										containerclassname="form-group"
										name="facilities_being_availed"
										type="text"
										ref={register({
											// required: true,
											maxLength: {
												value: 40,
												message: 'Maximum characters',
											},
										})}
										error={errors.facilities_being_availed}
									/>
								</div>
								<div className="col-md-4">
									<TextBox
										// required
										label="Loan Size Being Availed From Other Banks"
										placeholder="Please enter your response"
										containerclassname="form-group"
										name="loan_size_availed"
										type="text"
										ref={register({
											// required: true,
											maxLength: {
												value: 40,
												message: 'Maximum characters',
											},
										})}
										error={errors.loan_size_availed}
									/>
								</div>
								<div className="col-md-4">
									<TextBox
										// required
										label="For How Long The Firm Has Been Availing Loan From Other Banks"
										placeholder="Please enter your response"
										containerclassname="form-group"
										name="duration_firm_availing_loan"
										type="text"
										ref={register({
											// required: true,
											maxLength: {
												value: 40,
												message: 'Maximum characters',
											},
										})}
										error={errors.duration_firm_availing_loan}
									/>
								</div>
							</React.Fragment>
						)}
					</div>

					<div className="row formLayout-footer">
						<div className="col-12 text-right">
							<div className="bg-grey">
								<button
									type="button"
									onClick={() => {
										let activeStep = loanApplicationRoutes.find((route) => route.id == '3');
										//history.push(`/${urlFirstSegment + activeStep.path}/1/${params.id}`);
										window.location.href=`/${urlFirstSegment + activeStep.path}/1/${params.id}`
									}}
									className="btn btn-primary--solid px-4 py-2 btn-sm btn--medium  ml-2 "
								>
									Previous
								</button>
								<button
									type="button"
									title='Save the record to continue later.'
									onClick={() => {
										setIsDraft(true);
										clearErrors();
										handleSubmitDraft();
									}}
									className="btn btn-primary--solid px-4 py-2 btn-sm btn--medium  ml-2 "
								>
									Save to draft
								</button>
								<button
									type="submit"
									title='Save the record to continue later.'
									onClick={(e) => {
										// e.preventDefault();
										setIsDraft(false);
									}}
									className="btn btn-gradient--solid px-4 py-2 btn-sm btn--medium   ml-2"
								>
									Next and continue
								</button>
							</div>
						</div>
					</div>
					{updateSMELoanData.loading && <HoverLoader />}
				</form>
			) : miniStep === 3 ? (
				<form onSubmit={handleSubmit(onSubmit)}>
					<div className="row formLayout-row">
						<div className="col-12 ">
							<h4 className="formHeading">
								{/* <FormattedMessage id="Other Facilities" /> */}
								Facilities Availed from other Banks
								{/* <FormattedMessage id="Facilities Available to Other Banks" /> */}
							</h4>
						</div>
						<TextBox type="hidden"  name="miniStep" value="3" />
						<div className="col-6">
							<div className="form-group row justify-content-between">
								<div className="col-md-4">
									<label>
										Credit Card <b className="text-danger">*</b>
									</label>
								</div>
								<div className="col-md-8">
									
									<div className="d-flex">
										<div className="mx-3">
											<input type="radio" value="yes" name="credit_card" id="credit_card_yes" onChange={() => setIsCreditCard(true)} ref={register({ required: true })} />
											<label className="ml-2" htmlFor="credit_card_yes">
												Yes
											</label>
										</div>
										<div className="mx-3">
											<input type="radio" value="no" name="credit_card" id="credit_card_no" onChange={() => setIsCreditCard(false)} ref={register({ required: true })} />
											<label className="ml-2" htmlFor="credit_card_no">
												No
											</label>
										</div>
									</div>
								</div>
								{/* error message */}
								<FormErrorMessage error={errors.credit_card} />
							</div>

							{isCreditCard ? (
								<TextBox
									containerclassname="form-group"
									required
									type="text"
									label="Name of the Bank"
									name="name_bank_with_credit_card"
									ref={register({
										required: true, 
									})}
									error={errors.name_bank_with_credit_card}
								/>
							) : null}
						</div>
						<div className="col-6">
							<div className="form-group row justify-content-between">
								<div className="col-md-4">
									<label>
										POS <b className="text-danger">*</b>
									</label>
								</div>
								<div className="col-md-8">
									<div className="d-flex">
										<div className="mx-3">
											<input type="radio" value="yes" id="pos_yes" name="pos" onChange={() => setIsPos(true)} ref={register({ required: true })} />
											<label className="ml-2" htmlFor="pos_yes">
												Yes
											</label>
										</div>
										<div className="mx-3">
											<input type="radio" value="no" id="pos_no" name="pos" onChange={() => setIsPos(false)} ref={register({ required: true })} />
											<label className="ml-2" htmlFor="pos_no">
												No
											</label>
										</div>
									</div>
								</div>

								{/* error message */}
								<FormErrorMessage error={errors.pos} />
							</div>
							{isPos ? (
								<TextBox
									containerclassname="form-group"
									required
									type="text"
									label="Name of the Bank"
									name="name_bank_with_pos"
									ref={register({
										required: true,
									})}
									error={errors.name_bank_with_pos}
								/>
							) : null}
						</div>
						<div className="col-6">
							<div className="form-group row justify-content-between">
								<div className="col-md-4">
									<label>
										QR Code <b className="text-danger">*</b>
									</label>
								</div>
								<div className="col-md-8">
									<div className="d-flex">
										<div className="mx-3">
											<input type="radio" value="yes" name="qr_code" id="qr_code_yes" onChange={() => setISQrCode(true)} ref={register({ required: true })} />
											<label className="ml-2" htmlFor="qr_code_yes">
												Yes
											</label>
										</div>
										<div className="mx-3">
											<input type="radio" value="no" name="qr_code" id="qr_code_no" onChange={() => setISQrCode(false)} ref={register({ required: true })} />
											<label className="ml-2" htmlFor="qr_code_no">
												No
											</label>
										</div>
									</div>
								</div>

								{/* error message */}
								<FormErrorMessage error={errors.qr_code} />
							</div>
							{isQrCode ? (
								<TextBox
									containerclassname="form-group"
									required
									type="text"
									label="Name of the Bank"
									name="name_bank_with_qrcode"
									ref={register({
										required: true,
									})}
									error={errors.name_bank_with_qrcode}
								/>
							) : null}
						</div>
						<div className="col-6">
							<div className="form-group row justify-content-between">
								<div className="col-md-4">
									<label>
										Online Banking <b className="text-danger">*</b>
									</label>
								</div>
								<div className="col-md-8">
									<div className="d-flex">
										<div className="mx-3">
											<input type="radio" value="yes" name="online_banking" id="online_banking_yes" onChange={() => setIsOnlineBanking(true)} ref={register({ required: true })} />
											<label className="ml-2" htmlFor="online_banking_yes">
												Yes
											</label>
										</div>
										<div className="mx-3">
											<input type="radio" value="no" name="online_banking" id="online_banking_no" onChange={() => setIsOnlineBanking(false)} ref={register({ required: true })} />
											<label className="ml-2" htmlFor="online_banking_no">
												No
											</label>
										</div>
									</div>
								</div>

								{/* error message */}
								<FormErrorMessage error={errors.online_banking} />
							</div>
							{isOnlineBanking ? (
								<TextBox
									containerclassname="form-group"
									required
									type="text"
									label="Name of the Bank"
									name="name_bank_with_online_banking"
									ref={register({
										required: true,
									})}
									error={errors.name_bank_with_online_banking}
								/>
							) : null}
						</div>
						<div className="col-6">
							<div className="form-group row justify-content-between">
								<div className="col-md-4">
									<label>
										Mobile Banking <b className="text-danger">*</b>
									</label>
								</div>
								<div className="col-md-8">
									{' '}
									<div className="d-flex ">
										<div className="mx-3">
											<input type="radio" value="yes" name="mobile_banking" id="mobile_banking_yes" onChange={() => setIsMobileBanking(true)} ref={register({ required: true })} />
											<label className="ml-2" htmlFor="mobile_banking_yes">
												Yes
											</label>
										</div>
										<div className="mx-3">
											<input type="radio" value="no" name="mobile_banking" id="mobile_banking_no" onChange={() => setIsMobileBanking(false)} ref={register({ required: true })} />
											<label className="ml-2" htmlFor="mobile_banking_no">
												No
											</label>
										</div>
									</div>
								</div>

								{/* error message */}
								<FormErrorMessage error={errors.mobile_banking} />
							</div>
							{isMobileBanking ? (
								<TextBox
									containerclassname="form-group"
									required
									type="text"
									label="Name of the Bank"
									name="name_bank_with_mobile_banking"
									ref={register({ required: true })}
									error={errors.name_bank_with_mobile_banking}
								/>
							) : null}
						</div>
					</div>

					<div className="row formLayout-footer">
						<div className="col-12 text-right">
							<button
								type="button"
								onClick={() => {
									let activeStep = loanApplicationRoutes.find((route) => route.id == '3');
									//history.push(`/${urlFirstSegment + activeStep.path}/2/${params.id}`);
									window.location.href=`/${urlFirstSegment + activeStep.path}/2/${params.id}`;
								}}
								className="btn btn-primary--solid px-4 py-2 btn-sm btn--medium  ml-2 "
							>
								Previous
							</button>
							<button
								type="button"
								title='Save the record to continue later.'
								onClick={() => {
									setIsDraft(true);
									clearErrors();
									handleSubmitDraft();
								}}
								className="btn btn-primary--solid px-4 py-2 btn-sm btn--medium  ml-2 "
							>
								Save to draft
							</button>
							<button
								type="submit"
								title='Save the record to continue later.'
								onClick={(e) => {
									setIsDraft(false);
								}}
								className="btn btn-gradient--solid px-4 py-2 btn-sm btn--medium  ml-2"
							>
								Save and Continue
							</button>
						</div>
					</div>
					{updateSMELoanData.loading && <HoverLoader />}
				</form>
			) : miniStep === 4 ? (
				<form onSubmit={handleSubmit(onSubmit)}>
					<div className="row formLayout-row">
						<div className="col-12 ">
							<h4 className="formHeading">
								<FormattedMessage id="Terms and Conditions" />
							</h4>
						</div>
					<TextBox type="hidden"  name="miniStep" value="4" />
						<div className="col-12">
							{termsCondition.map((item, index) => (
								<>
								<div className="form-check form-group" key={index}>
									<input
										type="checkbox"
										value={item.value}
										className="form-check-input"
										id={`termsCondition${index}`}
										name={`terms_condition.[${index}]`}
										checked={item.isAdded}										
										ref={register({ required: true })}
										onChange={onAddingItem}
										onClick={onCheckingTerms}
									/>
									<label className="form-check-label" htmlFor={`termsCondition${index}`}>
										{item.label}
									</label>
								</div>
								<FormErrorMessage error={errors?.['terms_condition']?.[index]} />
								</>
							))}
						</div>
					</div>
					<div className="row formLayout-footer">
						<div className="col-12 text-right">
							<button
								type="button"
								onClick={() => {
									let activeStep = loanApplicationRoutes.find((route) => route.id == '3');
									//history.push(`/${urlFirstSegment + activeStep.path}/3/${params.id}`);
									window.location.href=`/${urlFirstSegment + activeStep.path}/3/${params.id}`
								}}
								className="btn btn-primary--solid px-4 py-2 btn-sm btn--medium  ml-2 "
							>
								Previous
							</button>
							<button
								type="button"
								title='Save the record to continue later.'
								onClick={() => {
									setIsDraft(true);
									clearErrors();
									handleSubmitDraft();
								}}
								className="btn btn-primary--solid px-4 py-2 btn-sm btn--medium  ml-2 "
							>
								Save to draft
							</button>
							<button
								type="submit"
								onClick={() => {
									
									setIsDraft(false);
								}}
								className="btn btn-gradient--solid px-4 py-2 btn-sm btn--medium  ml-2"
							>
								Save
							</button>
						</div>
					</div>
					{updateSMELoanData.loading && <HoverLoader />}
				</form>
			) : (
				''
			)}
		</>
	);
};

export default LoanApplicationStepThree;
